const hideElementsFunction = (
  dataName,
  effectingArrayOfHtmlElements
) => `[...${effectingArrayOfHtmlElements}].forEach((element, index) => {
        if (index >= ${dataName}.length - (chunk-1)*${effectingArrayOfHtmlElements}.length) {
            ${effectingArrayOfHtmlElements}[index].style.display = 'none';
        }
        else {
            ${effectingArrayOfHtmlElements}[index].style.display = "";
        }
      });`;

const fillPaginationMap = (effectingArrayOfHtmlElements,dataName) => {
  return `map.set(${effectingArrayOfHtmlElements}[i-(chunk-1) * ${effectingArrayOfHtmlElements}.length].getAttribute('id'), ${dataName}[${dataName}.length-i-1])`
}
    
const structureManipulateData = (
  dataName,
  effectingArrayOfHtmlElements
) => `${dataName}.forEach((item, i) => {

        let revertIndex = ${dataName}.length - i -1;

        if(${dataName}.length - chunk*${effectingArrayOfHtmlElements}.length <= revertIndex && revertIndex < ${dataName}.length - (chunk-1)*${effectingArrayOfHtmlElements}.length){
            <subElementsManipulator>
            <fillMap>
        }
        <storeMapInLocaleStorage>
    })
    `;

const createInsideApiContent = (elementType) => {
  let insideContent = elementType.elementTemplate.templateToGetSubElements(
    elementType.complexMethodId
  );

  insideContent += elementType.newMapTemplate();

  insideContent += hideElementsFunction(
    elementType.dataNameOfLoop,
    elementType.elementTemplate.elementArrayName
  );
  insideContent += structureManipulateData(
    elementType.dataNameOfLoop,
    elementType.elementTemplate.elementArrayName
  );
  const uniqueQueries = new Set([...elementType.gatherComplexQueries(), ...elementType.gatherSimpleQueries()]);

  const tryAndCatch = [...uniqueQueries]
    .map((queryCommand) => elementType.tryCatchTemplate(queryCommand))
    .reduce((acc, command) => acc + command, '');

  if (tryAndCatch !== '') {
    insideContent = insideContent.replace('<subElementsManipulator>', tryAndCatch);
    insideContent = insideContent.replaceAll('<selectAdvanceLoopTemplate>','');
    insideContent = insideContent.replaceAll('<selectAdvanceOuterTemplate>','');
  } else {
    insideContent = insideContent.replace(
      '<subElementsManipulator>',
      `console.log('There are no inside data elements');`
    );
  }

  insideContent = insideContent.replace('<storeMapInLocaleStorage>',elementType.storeMapInLocalStorage);
  insideContent = insideContent.replace('<fillMap>', fillPaginationMap(  elementType.elementTemplate.elementArrayName, elementType.dataNameOfLoop));
    
  return insideContent;
};

const editActivePaginationButtonsClass = (compId) => `
    for (let i = 0; i < pagination.children.length; i++) {
      if (
        pagination.children[i].classList.value.includes("active") === true
      ) {
        pagination.children[i].classList.remove("active");
      }
    }

    let numberOfFrontButtons =  findTypeOfPagination${compId}(pagination);
    pagination.children[chunk+numberOfFrontButtons-1].classList.add("active");\n
  `;

const createReturnChunkIndex = (compId) => `
    const returnChunkIndex${compId} = (chunk, numberOfPages, cause) => {

      if(cause === '+'){
        if(chunk < numberOfPages){
          return chunk + 1;
        }
        else{
          return chunk;
        }
      }
      else if(cause === '-'){
        if(chunk > 2){
          return chunk - 1;
        }
        else{
          return 1;
        }
      }
    }
  `;
  
const createFindTypeOfPagination = (compId) => `
    const findTypeOfPagination${compId} = (pagination) => {

      let firstChild = pagination.children[0];
      let secondChild = pagination.children[1];

      if (
        (firstChild.attributes.getNamedItem("pagination-first") !== null ||
          firstChild.attributes.getNamedItem("pagination-previous") !== null) &&
        (secondChild.attributes.getNamedItem("pagination-first") !== null ||
          secondChild.attributes.getNamedItem("pagination-previous") !== null)
      ) {
        return 2;
      } else if  (
        (firstChild.attributes.getNamedItem("pagination-first") !== null ||
          firstChild.attributes.getNamedItem("pagination-previous") !== null) ||
        (secondChild.attributes.getNamedItem("pagination-first") !== null ||
          secondChild.attributes.getNamedItem("pagination-previous") !== null)
      ) {
        return 1;
      }
      else{
        return 0;
      }

    }
  `;

const createOnClickFunction = (methodArray) => {
  const {compId} = methodArray;
  let js = `const onClickPaginationButton${compId} = (chunk, pagination) => {${editActivePaginationButtonsClass(compId)}${
    methodArray.apiCallPromisified
  }}`;

  js = js.replace('/**nextFunction*/', createInsideApiContent(methodArray.returnType));

  js = `${js}\n${createFindTypeOfPagination(compId)}`;
  js = `${js}\n${createReturnChunkIndex(compId)}`;

  return js;
};

const addPagination = (methodArray) => createOnClickFunction(methodArray);

export default addPagination;
